/**
* Testimonial Text Only Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonial Text Only Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'testimonial-text-only-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.testimonial-text-only-slider' ).each( function( key, component ) {
        $( component ).find( '.testimonial-text-slider__slider' ).slick( {
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: '.testimonial-text-slider__prev-btn',
          nextArrow: '.testimonial-text-slider__next-btn',
          arrowsPlacement: 'split',
          draggable: false,
        } );
      } );

      // Changes focus state of the button when the button is inside the slide
      $( '.testimonial-text-slider__slider' ).on( 'afterChange', function( event, slick, currentSlide, nextSlide ) {
        // on slide change get the active element
        const activeBtn = $( document.activeElement );
        // if the active element is the previous button focus the previous slide button
        if ( activeBtn.hasClass( 'testimonial-text-slider__prev-btn' ) ) {
          if ( currentSlide === ( slick.$slides.length - 1 ) ) {
            // chek if its the last slide and add a setTimeout to avoid issues with slick slide and extra slides
            setTimeout( () => {
              $( '.testimonial-text-slider__slider .slick-current .testimonial-text-slider__prev-btn' ).trigger( 'focus' );
            }, 0 );
          } else {
            // add focus to prev button if its not the last slide
            $( slick.$slides.get( currentSlide ) ).find( '.testimonial-text-slider__prev-btn' ).trigger( 'focus' );
          }
          // if the next button was clicked add focus to the next button on the next slide
        } else if ( activeBtn.hasClass( 'testimonial-text-slider__next-btn' ) ) {
          $( slick.$slides.get( currentSlide ) ).find( '.testimonial-text-slider__next-btn' ).trigger( 'focus' );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonial-text-only-slider', COMPONENT );
} )( app );
